import cn from 'classnames';

import RichText from 'components/rich-text/RichText';

import { IRecord } from 'source/NFR.types';

interface RecordProps extends IRecord {
  shouldFade?: boolean;
  hideLine?: boolean;
}

const Record: React.FC<RecordProps> = ({ date, richText, shouldFade, hideLine }) => (
  <div className="timeline-vertical--record">
    <div className="timeline-vertical--record-date">{date}</div>
    <div className="timeline-vertical--record-timeline">
      <div className="timeline-vertical--record-timeline-marker"></div>
      <div
        className={cn('timeline-vertical--record-timeline-line', {
          '-fade-bottom': shouldFade,
          '-hide': hideLine
        })}
      />
    </div>
    <RichText className="timeline-vertical--record-text" {...richText} />
  </div>
);

Record.displayName = 'Record';

export default Record;
